/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  MenuItem,
  MenuList,
  TextField
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import debounce from 'lodash.debounce'
import React, { useContext, useEffect, useRef, useState } from 'react'

import { getHomePartnersList, getSearch, saveHomePartnersList } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import Context from '../../context'
import history from '../../services/history'

function HomePartners() {
  const { setUser, setAboutCurrentPage } = useContext(Context)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [searchPartnersModalVisible, setSearchPartnersModalVisible] = useState(false)

  const partnersShape = {
    data: [],
    loading: false,
    query: '',
    chosen: null,
    showOptions: false
  }
  const [partners, setPartners] = useState(partnersShape)
  const classes = useStyles()

  useEffect(() => {
    if (!isAuthenticated()) return history.replace('/')

    setUser(getLoggedUser)
    getData()
  }, [])

  useEffect(() => {
    setAboutCurrentPage({
      title: 'Parceiros Destaque Home',
      buttons: [{ title: 'Salvar', onClick: save }]
    })
  }, [data])

  async function getData() {
    try {
      setLoading(true)
      let data = await getHomePartnersList()
      setData(data)
    } catch {
      //
    } finally {
      setLoading(false)
    }
  }

  function showSearchPartnersModal() {
    setSearchPartnersModalVisible(true)
  }

  function hideSearchPartnersModal() {
    setSearchPartnersModalVisible(false)
    setPartners(partnersShape)
  }

  function setPartnersInfo(param) {
    setPartners(partners => ({ ...partners, ...param }))
  }

  function getPartners(query) {
    setPartnersInfo({ query })
    searchPartners(query)
  }

  const searchPartners = useRef(
    debounce(async query => {
      if (query.trim().length < 4) return

      setPartnersInfo({ loading: true })
      const data = await getSearch('partner', query)
      setPartnersInfo({
        data,
        loading: false
      })
    }, 350)
  ).current

  function select(partner) {
    setPartnersInfo({
      showOptions: false,
      query: partner.fantasyName,
      chosen: partner
    })
  }

  function add() {
    setData(data => [
      ...data,
      {
        id: partners.chosen.id,
        fantasyName: partners.chosen.fantasyName,
        shouldAppearOnHome: data.length + 1
      }
    ])
    hideSearchPartnersModal()
  }

  function oneUp(index) {
    return function () {
      setData(data =>
        [...data.slice(0, index - 1), data[index], data[index - 1], ...data.slice(index + 1)].map(
          (item, i) => ({
            ...item,
            shouldAppearOnHome: i + 1
          })
        )
      )
    }
  }

  function oneDown(index) {
    return function () {
      setData(data =>
        [...data.slice(0, index), data[index + 1], data[index], ...data.slice(index + 2)].map(
          (item, i) => ({
            ...item,
            shouldAppearOnHome: i + 1
          })
        )
      )
    }
  }

  function remove(index) {
    return function () {
      setData(data =>
        [...data.slice(0, index), ...data.slice(index + 1)].map((item, i) => ({
          ...item,
          shouldAppearOnHome: i + 1
        }))
      )
    }
  }

  async function save() {
    try {
      setLoading(true)
      await saveHomePartnersList(data)
      setData(null)
      await getData()
    } catch {
      //
    }
  }

  return (
    <>
      <div className={classes.outerContainer}>
        <div className={classes.content}>
          <div className={classes.row}>
            <div className={classes.filters}>
              <div className={clsx(classes.actions, classes.row)}>
                <button type="button" onClick={showSearchPartnersModal}>
                  Incluir parceiro
                </button>
              </div>
            </div>
          </div>
          <table className={classes.table}>
            <colgroup>
              <col />
              <col className={classes.fitContent} />
            </colgroup>
            <thead>
              <tr>
                <td>Parceiro</td>
                <td>Posição</td>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                data?.map((item, index, { length }) => (
                  <tr key={item.id}>
                    <td className={classes.titleContainer}>
                      <div>{item.fantasyName}</div>
                      <div>
                        {index > 0 && (
                          <>
                            <a onClick={oneUp(index)}>Subir</a>
                            {' | '}
                          </>
                        )}
                        {index < length - 1 && (
                          <>
                            <a onClick={oneDown(index)}>Descer</a>
                            {' | '}
                          </>
                        )}
                        <a onClick={remove(index)}>Remover</a>
                      </div>
                    </td>
                    <td>#{item.shouldAppearOnHome}</td>
                  </tr>
                ))}
              {!loading && data?.length === 0 && (
                <tr>
                  <td colSpan="2">Nenhum resultado</td>
                </tr>
              )}
            </tbody>
          </table>
          {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
        </div>
      </div>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={searchPartnersModalVisible}
        onClose={hideSearchPartnersModal}
        transitionDuration={{
          enter: 250,
          exit: 0
        }}
      >
        <DialogTitle>Procurar parceiro</DialogTitle>
        <DialogContent className={classes.dialog}>
          <div className={classes.dialogInner}>
            <TextField
              fullWidth
              value={partners.query}
              onFocus={() => setPartnersInfo({ showOptions: true })}
              onChange={e => getPartners(e.target.value)}
            />
            {partners.showOptions && (
              <MenuList className={classes.menuList}>
                {partners.loading && <MenuItem disabled>Pesquisando...</MenuItem>}
                {!partners.loading && partners.data.length === 0 && (
                  <MenuItem disabled>
                    {partners.query.trim().length < 4
                      ? 'Pesquise um termo'
                      : 'Nenhum resultado encontrado'}
                  </MenuItem>
                )}
                {partners.data.map(partner => (
                  <MenuItem key={partner.id} onClick={() => select(partner)}>
                    {partner.fantasyName}
                  </MenuItem>
                ))}
              </MenuList>
            )}
          </div>
        </DialogContent>
        {partners.chosen && (
          <DialogActions>
            <Button color="primary" onClick={add}>
              Adicionar
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '40px 45px'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  filters: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginRight: 30,
    padding: '12px 10px 10px',
    borderBottom: '2px solid #30287b'
  },
  actions: {
    '& button': {
      marginRight: 10,
      padding: '6px 15px',
      fontSize: '12px',
      fontWeight: 700,
      color: '#30287b',
      lineHeight: '15px',
      backgroundColor: '#ece5fe',
      border: 'none',
      borderRadius: 2
    }
  },
  table: {
    marginTop: '20px',
    whiteSpace: 'nowrap',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b'
    },
    '& thead': {
      background: '#30287b'
    },
    '& thead td': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase'
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b'
    }
  },
  fitContent: {
    width: 'fit-content'
  },
  titleContainer: {
    '& div:first-child': {
      marginBottom: '17px',
      fontWeight: '700'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer'
      },
      '& a:not(:last-child)': {
        color: '#30287b'
      },
      '& a:last-child': {
        color: '#d73f32'
      }
    }
  },
  dialog: {
    minHeight: 300
  },
  dialogInner: {
    position: 'relative'
  },
  menuList: {
    position: 'absolute',
    width: '100%',
    top: '100%',
    left: 0,
    background: '#ece5fe',
    zIndex: 10
  }
})

export default HomePartners
